import { ProductTeam } from '@fullstory/proto/fs/services/lassie';
import { IssueTrackingRequestActions } from './actions';
import { IssueTrackingRequestTypes } from './types';

export const issueTrackingReducer = (
  state: ProductTeam[] = [],
  action: IssueTrackingRequestActions,
): ProductTeam[] => {
  switch (action.type) {
    case IssueTrackingRequestTypes.GetProductTeamsSuccess: {
      return action.data.productTeams;
    }
    default:
      return state;
  }
};
